// =============================================================================
// Progress store — localStorage["epos-academy-progress"], frozen schema:
//   { "progress": { "<docId>": 0..100 }, "lastDoc": "<docId>" }
// Values clamp to 0–100 and only ever increase (monotonic); done is >= 95.
// Same store for guests and logged-in users (per behavior spec).
// =============================================================================

const KEY = "epos-academy-progress";

export const DONE_PCT = 95;

const clamp = (v) => Math.max(0, Math.min(100, Math.round(Number(v) || 0)));

export function loadStore() {
	try {
		const raw = JSON.parse(localStorage.getItem(KEY) || "null");
		if (!raw || typeof raw !== "object") {
			return { progress: {}, lastDoc: null };
		}
		const progress = {};
		for (const [slug, value] of Object.entries(raw.progress || {})) {
			progress[slug] = clamp(value);
		}
		return {
			progress,
			lastDoc: typeof raw.lastDoc === "string" ? raw.lastDoc : null,
		};
	} catch (e) {
		return { progress: {}, lastDoc: null };
	}
}

export function getPct(slug) {
	return loadStore().progress[slug] || 0;
}

/**
 * Monotonic write + lastDoc update; broadcasts "aa-progress" so the nav
 * labels and setup card re-hydrate without a reload.
 */
export function recordPct(slug, value) {
	if (!slug) {
		return 0;
	}
	const store = loadStore();
	const next = clamp(value);
	if ((store.progress[slug] || 0) < next) {
		store.progress[slug] = next;
	}
	store.lastDoc = slug;
	try {
		localStorage.setItem(KEY, JSON.stringify(store));
	} catch (e) {
		// Private mode etc. — tracking degrades silently.
	}
	window.dispatchEvent(
		new CustomEvent("aa-progress", {
			detail: { slug, pct: store.progress[slug] || 0 },
		})
	);
	return store.progress[slug] || 0;
}

export const isDone = (pct) => pct >= DONE_PCT;

export const statusLabel = (pct) =>
	isDone(pct) ? "Done" : pct > 0 ? `${pct}%` : "0%";
